module.exports = __webpack_public_path__ + "static/media/logo176.359be132.png";